<!--模板-->
<template>
  <div id="accompanyBg" class="zwcWidth">
    <div class="lefttitle">
      <div v-for="(item,index) of typesOf" :key="index" v-if="item">
        <h4> <span class="iconfont">&#xe6ae;</span>{{item.name}}</h4>
        <ul>
          <li v-for="(list,key) of item.child" :key="key" :class="list.code == pushType ? 'cor' : ''" @click="typeItem(list)">
            <img :src="list.image" alt=""> {{list.name}}
          </li>
        </ul>
      </div>
    </div>
    <!-- 卡片 -->
    <div class="seconedWidth card" v-if="servesList">
      <el-row>
        <el-col class="card_list mar10" :span="8" v-for="(item,index) in servesList.data" :key="index" :offset="index > 0 ? 4 : 0" @click="serviceBtn(item)">
          <el-card :body-style="{padding: '0px'}" style="position: relative">
            <img :src="item.thumb" class="card_image" @click="serviceBtn(item)">
            <div class="name_img" @click="serviceBtn(item)">
              <img :src="item.userInfo[0].avatar" alt="">
              <span>{{item.userInfo[0].nickname}}</span>
            </div>
            <div style="padding: 20px 10px;" @click="serviceBtn(item)">
              <span class="name_title">{{item.title}}</span>
              <div class=" clearfix">
                <time class="time">{{item.typeText}}
                  <!--<span></span>四点九分-->
                </time>
                <time type="text" class="button">￥{{item.price}}元 / {{item.priceTypeText}}</time>
                <!-- <time type="text" class="button">推荐</time> -->
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <p style="text-align: right" v-if="servesList.data.length > 1">
        <el-pagination background @size-change="handleSizeChange" @current-change="pageChange" :current-page="page" :page-sizes="[30, 50, 80, 100]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="totalData">
        </el-pagination>
      </p>
      <div v-if="servesList.data.length == 0">
        <empty :acceptEmptyData="acceptEmptyData"></empty>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
import http from 'api/api'
import empty from '../../components/common/empty'
export default {
  components: {
    empty
  },
  data () {
    return {
      acceptEmptyData: {
        from: 'services',
        msg: '暂无服务提供，您可抢先去发布服务～'
      },
      offsetCount: 0,
      input5: '',
      servesList: '',
      searchTextData: '',
      regionList: '',
      totalData: 0,
      page: 1,
      pageSize: 30,
      typesOf: [],
      pushType: ''
    }
  },
  methods: {
    typeItem (item) {
      this.pushType = item.code
      // 获取服务服务列表
      this.getList()
    },
    handleSizeChange (val) {
      this.pageSize = val
      // 获取服务服务列表
      this.getList()
      console.log(`每页 ${val} 条`);
    },
    pageChange (val) {
      this.page = val
      // 获取服务服务列表
      this.getList()
      console.log(this.page, val, "翻页")
    },
    serviceBtn (item) {
      console.log(item)
      this.$router.push('/homePage?nameCode=' + item.userInfo[0]._id + '&nameService=' + item._id)
    },
    // 获取列表
    getList () {
      // 获取服务服务列表
      http.GET('/jw-service', {
        module: 'service',
        operation: 'serviceList',
        serviceType: 1,
        type: 2
      }).then((res) => {
        this.servesList = res
      })
    }
  },
  mounted () {
    // 获取服务服务列表
    this.getList()
    // 获取分类
    http.GET('/jw-function', {
      module: 'product',
      operation: 'getCategory'
    }).then((res) => {
      this.typesOf = res
    })
  }
}
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../scss/commonH5.scss';
.cor {
  background: $fontHover;
  color: #fff;
  border-radius: 10px;
}
.icon {
  span {
    color: #ec6106;
  }
}
#accompanyBg {
  display: flex;
  position: fixed;
}
.lefttitle {
  background: #474664;
  width: 280px;
  height: 100vh;
  color: #fff;
  overflow-y: scroll;
  padding: 0 0 100px 0;
  box-sizing: border-box;
  h4 {
    margin-top: 30px;
    padding: 0 10px;
    color: #fff;
    font-weight: bold;
    border-bottom: 1px solid #fff;
    span {
      font-size: 20px;
    }
  }
  ul {
    li {
      width: 45%;
      display: flex;
      padding: 15px 10px;
      box-sizing: border-box;
      display: inline-block;
      text-align: left;
      cursor: pointer;
      margin: 5px;
      img {
        width: 20px;
        height: 20px;
        padding-right: 5px;
        display: inline-block;
      }
    }
    li:hover {
      background: $fontHover;
      color: #fff;
      border-radius: 10px;
    }
  }
}
/*内层居中样式*/
.seconedWidth {
  width: 85%;
  height: 100vh;
  overflow-y: scroll;
}
.mar10 {
  margin-bottom: 20px;
}
.name_title {
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  padding: 6px 8px;
  margin-bottom: 12px;
  background: #3a3956;
  border-radius: 4px;
  color: #fff;
}
.infinite-list {
  height: 300px;
  background: #ddd;
}
.card_list {
  cursor: pointer;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
}
.card_list:hover {
  opacity: 0.8;
  filter: alpha(opacity=80);
  transform: scale(1.03);
  -webkit-transform: scale(1.03);
  -moz-transform: scale(1.03);
}
.card_list img {
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  border-radius: 5px;
}
.card_list:hover .card_image {
  filter: alpha(opacity=80);
  transform: scale(1.1);
  border-radius: 5px;
}
.card_image {
  width: 100%;
  display: block;
  height: 230px;
}
.name_img span {
  color: #fff;
  font-size: 14px;
  padding-left: 5px;
}
.name_img {
  position: absolute;
  top: 190px;
  left: 28px;
}
.name_img img {
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
.classify_bg table {
  border: 1px solid #ddd;
  font-size: 15px;
  width: 1000px;
}
.classify_bg tr {
  height: 50px;
  width: 100%;
  border: 1px solid #ddd;
}
.classify_bg td:first-child {
  width: 15%;
  background: #f5f5f5;
  text-align: right;
  padding: 0 20px;
}
.classify_bg td:last-child {
  width: 85%;
  padding: 0 20px;
}
.classify_bg {
  width: 1000px;
  margin: 30px auto 0;
  height: auto;
}
/*外层样式*/
.zwcWidth {
  width: 100%;
} // header头部
#header {
  height: 80px; // padding: 30px 0;
}
#header > div:first-child {
  padding-top: 15px;
}
#header img {
  display: block;
  width: 120px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu.el-menu--horizontal li {
  padding: 0;
  margin: 0 20px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.el-menu.el-menu--horizontal li:last-child {
  margin-right: 0;
}
/*面包屑导航*/
.el-breadcrumb {
  font-size: 14px;
  line-height: 1;
  text-align: right;
}
.el-breadcrumb span {
  float: inherit;
}
.r_nav {
  padding-top: 15px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #ff6600;
  color: #ff6600;
  border-bottom-color: #ff6600 !important;
}
.el-breadcrumb[data-v-297fe81f] {
  font-size: 12px;
  line-height: 1;
  text-align: right;
}
/*导航下大背景*/
.bg {
  background: url(../../../static/images/title/accompany.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 500px;
  display: flex;
}
.bg .flex {
  align-self: center;
  margin: auto;
}
.bg .flex h1 {
  color: #ffffff;
  font-size: 30px;
  text-align: center;
}
.bg .flex h3 {
  color: #ffffff;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}
.bg .flex .shade {
  width: 700px;
  height: 100px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  display: table;
  margin-top: 15px;
}
.el-select .el-input {
  width: 80px;
}
.el-input-group {
  width: 93%;
}
.el-input-group__append {
  background-color: $fontColor !important;
  color: #ffffff;
  border: 0;
}
/*玩行分类*/
.classify {
  padding: 60px 0 0 0;
}
.classify h2 {
  color: $fontColor;
  font-size: 25px;
  font-weight: 600;
  text-align: center;
}
.classify .border_b {
  margin: 10px 0;
}
.classify .border_b p {
  width: 250px;
  height: 1px;
  margin: auto;
  background-color: #e0dede;
}
.classify .border_b span {
  width: 25px;
  height: 2px;
  display: block;
  margin: auto;
  background-color: #2f2f2f;
}
.classify > p {
  color: #8d8a8a;
  text-align: center;
  font-size: 15px;
}
/*选项卡*/
.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  position: relative; // width: 400px;
  // height: 250px;
  // background-color: lightgrey;
}
.flex-container .left_arrow {
  background: url(../../../static/images/guide/jian.png) no-repeat;
  width: 35px;
  height: 50px;
  position: absolute;
  top: 15px;
  left: -80px;
  cursor: pointer;
}
.flex-container .rigth_arrow {
  background: url(../../../static/images/guide/jian.png) no-repeat;
  width: 35px;
  height: 50px;
  position: absolute;
  top: 15px;
  right: -80px;
  cursor: pointer;
  transform: rotate(180deg);
  -o-transform: rotate(180deg);
  /* Opera */
  -ms-transform: rotate(180deg);
  /* Internet Explorer */
  -moz-transform: rotate(180deg);
  /* Firefox */
  -webkit-transform: rotate(180deg);
  /* Safari 和 Chrome */
}
.flex-item img {
  // background-color: cornflowerblue;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.flex-item p {
  color: $fontColor;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  padding-top: 8px;
}
/*卡片*/
.time {
  font-size: 13px;
  border: 1px solid $fontColor;
  padding: 2px 10px;
  border-radius: 20px;
  color: $fontColor;
}
.time > span {
  width: 2px;
  height: 14px;
  background-color: #9b9b9b;
  display: inline-block;
  margin: 0 3px;
  vertical-align: -2px;
}
.bottom {
  margin-top: 13px;
  line-height: 12px;
}
.button {
  padding: 0;
  float: right;
  color: $fontColor;
  font-weight: 600;
}
.image {
  width: 100%;
  display: block;
}
.el-card {
  font-size: 15px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
.card {
  padding: 10px 20px;
  box-sizing: border-box;
}
.card .el-row:first-child {
  margin-bottom: 20px;
}
.el-col-8 {
  width: 25%;
  padding: 10px;
}
.el-col-offset-4 {
  margin-left: 0px !important;
}
/*底部*/
.bottom_bg {
  background-color: #020202; // margin-bottom: 300px;
}
.topL ul li {
  float: left;
  padding-right: 10px;
}
.topL ul li a {
  border-left: 2px solid #ffffff;
  padding-left: 10px;
  color: #ffffff;
  font-size: 14px;
}
.topL h5:first-child {
  margin-top: 15px !important;
}
.catListTitle {
  font-weight: bold;
  line-height: 17px;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
  color: #a4a4a4;
  padding: 0px 0px 0px 32px;
}
.topR img {
  width: 85px;
  height: 85px;
}
.topR p {
  text-align: center;
  font-size: 12px;
  color: #ffffff;
}
/* 下-底部 */
.b_base {
  margin: auto;
  display: table;
}
.b_base ul li {
  float: left;
}
.b_base ul li a {
  border-right: 2px solid #ffffff;
  padding-right: 5px;
  padding-left: 5px;
  color: #ffffff;
  font-size: 12px;
}
.record {
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  padding-bottom: 10px;
}
</style>

<style lang="scss">
#accompanyBg .zwcWidth {
  .el-input__inner {
    font-size: 21px !important;
    height: 65px !important;
    line-height: 65px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/list/hotList.vue